import type { SupervisorOrgUser } from "../supervisorOrg/index.js";

/** `approverOrgUsers` must be read at decision time: a supervisor demoted or removed after approving no longer counts. */
export const hasSupervisorApproval = (
  approvalUids: readonly string[],
  approverOrgUsers: readonly Pick<SupervisorOrgUser, "uid" | "role">[],
) =>
  approverOrgUsers.some(
    (orgUser) => orgUser.role === "supervisor" && approvalUids.includes(orgUser.uid),
  );

export const isTransferRequestAccepted = ({
  approvalUids,
  externalApprovers,
  approverOrgUsers,
}: {
  approvalUids: readonly string[];
  externalApprovers: readonly string[];
  approverOrgUsers: readonly Pick<SupervisorOrgUser, "uid" | "role">[];
}) =>
  externalApprovers.every((uid) => approvalUids.includes(uid)) &&
  hasSupervisorApproval(approvalUids, approverOrgUsers);

/**
 * Whether a review targets the stored version of a transfer request. `reviewedEditedAt` is the
 * `editedAt` the reviewer saw, in milliseconds, `null` or absent if they saw no edit. The client
 * SDK keeps a fractional millisecond that the Admin SDK floors.
 */
export const isReviewedTransferRequestVersion = ({
  storedEditedAt,
  reviewedEditedAt,
}: {
  storedEditedAt: { toMillis: () => number } | undefined;
  reviewedEditedAt: number | null | undefined;
}) =>
  (storedEditedAt?.toMillis() ?? null) ===
  (reviewedEditedAt === undefined || reviewedEditedAt === null
    ? null
    : Math.floor(reviewedEditedAt));
